// AUTO-GENERATED from `ash_large.json` — do not edit by hand. Regenerate via the preset
//   → `.ts` conversion script when the upstream preset JSONs change.
import type {DeepPartial, TreeOptions} from "../options.js";

const options: DeepPartial<TreeOptions> = {
    "seed": 29919,
    "type": "deciduous",
    "bark": {
      "type": "Bark001",
      "tint": 13552830,
      "flatShading": false,
      "textured": true,
      "textureScale": {
        "x": 0.5,
        "y": 5
      }
    },
    "branch": {
      "levels": 3,
      "angle": {
        "1": 39,
        "2": 39,
        "3": 51
      },
      "children": {
        "0": 10,
        "1": 4,
        "2": 3
      },
      "force": {
        "direction": {
          "x": 0,
          "y": 1,
          "z": 0
        },
        "strength": 0.01
      },
      "gnarliness": {
        "0": -0.05,
        "1": 0.2,
        "2": 0.16,
        "3": 0.049999999999999996
      },
      "length": {
        "0": 45,
        "1": 29.42,
        "2": 15.3,
        "3": 4.6
      },
      "radius": {
        "0": 3.03,
        "1": 0.53,
        "2": 0.79,
        "3": 1.11
      },
      "sections": {
        "0": 12,
        "1": 8,
        "2": 6,
        "3": 4
      },
      "segments": {
        "0": 8,
        "1": 6,
        "2": 4,
        "3": 3
      },
      "start": {
        "1": 0.32,
        "2": 0.34,
        "3": 0
      },
      "taper": {
        "0": 0.7,
        "1": 0.6199999999999999,
        "2": 0.7599999999999999,
        "3": 0
      },
      "twist": {
        "0": 0.09,
        "1": -0.07,
        "2": 0,
        "3": 0
      }
    },
    "leaves": {
      "type": "ash",
      "billboard": "double",
      "angle": 30,
      "count": 10,
      "start": 0.01,
      "size": 4.62,
      "sizeVariance": 0.72,
      "tint": 16777215,
      "alphaTest": 0.5
    },
    "trellis": {
      "enabled": false
    }
  };

export default options;
